import { Mp3Encoder } from '@breezystack/lamejs'

const MP3_BITRATE_KBPS = 128
const SAMPLES_PER_FRAME = 1152

const floatToInt16 = (samples: Float32Array) => {
  const output = new Int16Array(samples.length)

  for (let index = 0; index < samples.length; index += 1) {
    const sample = Math.max(-1, Math.min(1, samples[index] || 0))
    output[index] = sample < 0 ? sample * 32768 : sample * 32767
  }

  return output
}

/**
 * Converte a gravacao produzida pelo MediaRecorder (WebM, OGG ou MP4) em um
 * MP3 real. Mudar somente a extensao do arquivo nao converte o seu conteudo.
 */
export const convertRecordedAudioToMp3 = async (recordedBlob: Blob): Promise<Blob> => {
  const browserWindow = window as Window & typeof globalThis & {
    webkitAudioContext?: typeof AudioContext
  }
  const AudioContextConstructor = browserWindow.AudioContext || browserWindow.webkitAudioContext
  if (!AudioContextConstructor) {
    throw new Error('Este navegador nao oferece suporte para converter audio em MP3.')
  }

  const audioContext = new AudioContextConstructor()

  try {
    const input = await recordedBlob.arrayBuffer()
    const decoded = await audioContext.decodeAudioData(input.slice(0))
    const sourceSamples = decoded.getChannelData(0)
    const pcm = floatToInt16(sourceSamples)
    const encoder = new Mp3Encoder(1, decoded.sampleRate, MP3_BITRATE_KBPS)
    const mp3Parts: Int8Array[] = []

    for (let offset = 0; offset < pcm.length; offset += SAMPLES_PER_FRAME) {
      const encoded = encoder.encodeBuffer(pcm.subarray(offset, offset + SAMPLES_PER_FRAME))
      if (encoded.length > 0) mp3Parts.push(new Int8Array(encoded))
    }

    const finalPart = encoder.flush()
    if (finalPart.length > 0) mp3Parts.push(new Int8Array(finalPart))

    if (mp3Parts.length === 0) {
      throw new Error('Nao foi possivel gerar o arquivo MP3 da gravacao.')
    }

    return new Blob(mp3Parts, { type: 'audio/mpeg' })
  } finally {
    await audioContext.close().catch(() => undefined)
  }
}
